import http from '../axios';

export function list(params = {}) {
  return http.get('/vessels/list', { params });
}

export function dropdown(params = {}) {
  return http.get('/vessels/dropdown', { params });
}

export function create(payload){
  return http.post('/vessels', payload);
}

export function update(payload) {
  return http.patch(`/vessels/${payload.id}`, payload);
}

export function findVessel(vessel_name){
  return http.get('/vessels/find_vessel', {
    params: { vessel_name },
  });
}

export function getVesselInfo(vessel_name){
  return http.get('/vessels/get_vessel_info', {
    params: { vessel_name },
  });
}

export function show(id) {
  return http.get(`/vessels/${id}`);
}